import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL, brandColor } from "../../common/constant";

const ProjectsPage = () => {
  const [societies, setSocieties] = useState([]);
  const navigate = useNavigate();

  // Fetch societies data on component mount
  useEffect(() => {
    const fetchSocieties = async () => {
      try {
        const response = await fetch(`${API_URL}/api/society/get-all-societies`);

        console.log('response==>', response?.data)
        const data = await response.json();
        if (response.ok) {
          setSocieties(data.societies);
          console.log('data.societied', data.societies)
        } else {
          console.error("Failed to fetch societies:", data.message);
        }
      } catch (error) {
        console.error("Error fetching societies:", error);
      }
    };

    fetchSocieties();
  }, []);

 


  const handleNavigate = (society) => {
    navigate(`/project-details/${society._id}`);
  };

  return (
    <div className="px-4 sm:px-8 md:px-16 py-8 lg:px-36">
      <h3 className="text-4xl font-bold text-start mb-6" style={{ color: "#54BD95" }}>
        Societies Available
      </h3>
      <div className="flex flex-col gap-6">
        {societies.map((society) => (
          <div
            key={society._id}
            className="flex flex-col md:flex-row gap-4 border rounded-lg cursor-pointer shadow-lg p-4"
            onClick={() => handleNavigate(society)}
          >
            {/* Society Image */}
            <div className="flex-shrink-0">       
              <img
                src={`${API_URL}/uploads/societies/${society._id}/${society.mainImage}`}
                alt={society.name}
                className="w-full md:w-60 h-40 object-cover rounded-md"
                loading="lazy"
              />
              <p className="text-sm text-gray-500 mt-2">Posted: {new Date(society.createdAt).toDateString()}</p>
            </div>

            {/* Society Details */}
            <div className="flex-grow">
              <h4 className="text-lg font-bold">{society.name}</h4>
              <p className="text-sm text-gray-600 mt-2">{society.address}</p>
              <p className="text-sm text-gray-600 mt-2">{society.desc}</p>

              <p className="text-sm text-gray-500 mt-2">
                <span className="font-bold">Area: </span>
                {society.area}
              </p>
              <p className="text-sm text-gray-500 mt-2">
                <span className="font-bold">Facilities: </span>
                {society.facilities.join(", ")}
              </p>
            </div>

            {/* Price and Contact */}
            <div className="flex flex-col items-end">
              <p className="text-sm text-gray-500">
                <span className="font-bold" style={{color: brandColor}}>Range: </span>
                {society.range || "N/A"}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage;
